<ion-card>
    <ion-item lines="none" class="label-color">
        <ion-label>{{document.signLater ? 'Sign Later' : 'Sign Now'}}</ion-label>
        <ion-toggle slot="end" [(ngModel)]="document.signLater" (ionChange)="updateOperator()"></ion-toggle>
    </ion-item>
</ion-card>
